__turbopack_context__.v({
  "className": "secular_one_50e75845-module__3hbtOa__className",
});
